import { trackLine, liveNotes, type TrackItem } from "@/mocks/tracking";

const toneStyle: Record<TrackItem["tone"], { text: string; dot: string }> = {
  lock: { text: "text-mark-text", dot: "bg-mark" },
  verify: { text: "text-gold-text", dot: "bg-gold" },
  out: { text: "text-muted", dot: "bg-faint" },
  hot: { text: "text-mark-text", dot: "bg-mark" },
};

export default function TickerTrack() {
  return (
    <section id="track" className="w-full border-b border-line">
      {/* live 短讯带 */}
      <div className="border-b border-line bg-soft/70">
        <div className="mx-auto flex w-full max-w-6xl items-center gap-3 px-4 py-2 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap text-xs font-medium text-mark-text">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-mark opacity-60"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-mark"></span>
            </span>
            正在追踪
          </span>
          <div className="flex-1 overflow-hidden whitespace-nowrap">
            <div className="inline-flex animate-[scroll-x_36s_linear_infinite] gap-10">
              {liveNotes.concat(liveNotes).map((note, i) => (
                <span key={i} className="text-xs text-muted">
                  {note}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 持续追踪 · 新近事件推进 */}
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-medium uppercase tracking-widest text-gold-text">
              Ongoing Watch
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink md:text-3xl">
              持续追踪 · 新近事件推进线
            </h2>
            <p className="mt-2 text-sm text-muted">
              同一件事不会到「爆」就结束——按下时间轴看它如何一步步被扒清、对账、定论。
            </p>
          </div>
          <a
            href="#expose"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-mark-text hover:text-mark-deep"
          >
            查看近期流出 <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>

        <ol className="relative mt-8 space-y-4 border-l border-line pl-6">
          {trackLine.map((it, idx) => {
            const tone = toneStyle[it.tone];
            return (
              <li key={idx} className="relative">
                <span
                  className={`absolute -left-[31px] top-1.5 flex h-[11px] w-[11px] rounded-full ${tone.dot} ring-4 ring-paper`}
                ></span>
                <div className="rounded-lg border border-line bg-card px-4 py-3 transition-colors hover:bg-cream">
                  <div className="flex flex-wrap items-center gap-2 text-xs">
                    <span className="whitespace-nowrap text-faint">{it.time}</span>
                    <span className={`whitespace-nowrap font-medium ${tone.text}`}>{it.tag}</span>
                  </div>
                  <h3 className="mt-1 text-sm font-semibold text-ink md:text-base">{it.title}</h3>
                  <p className="mt-1 text-xs leading-relaxed text-muted md:text-sm">{it.brief}</p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}